export default "__VITE_ASSET__Ccus7NVb__"